/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const CheckCircleIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75m4.264-12.419a1 1 0 0 0-1.628-1.162l-3.689 5.164-1.79-1.79a1 1 0 0 0-1.414 1.414l2.625 2.625a1 1 0 0 0 1.52-.126z" clipRule="evenodd" /></svg>;
};
export default CheckCircleIcon;